module.exports = __webpack_public_path__ + "img/Based on Compassion.28729d6e.png";